import { render } from "./useCoupon.vue?vue&type=template&id=6d64b976&scoped=true"
import script from "./useCoupon.vue?vue&type=script&lang=js"
export * from "./useCoupon.vue?vue&type=script&lang=js"

import "./useCoupon.vue?vue&type=style&index=0&id=6d64b976&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d64b976"]])

export default __exports__